// extracted by mini-css-extract-plugin
export var container = "R_c";
export var grid = "R_cq";
export var header = "R_q";
export var section = "R_b";